interface TreatmentEpisode {
  treatmentPrograms?: unknown[] | null;
}

interface CarePlanStatusParams {
  activeTreatmentEpisode?: TreatmentEpisode;
  hasActivePrimaryDiagnosis: boolean;
  hasActiveModality: boolean;
  isModalityOptional: boolean;
}

export const getCarePlanStatusMessage = ({
  activeTreatmentEpisode,
  hasActivePrimaryDiagnosis,
  hasActiveModality,
  isModalityOptional,
}: CarePlanStatusParams): string => {
  if (!activeTreatmentEpisode) {
    return 'A treatment episode must be added before a care plan can be created.';
  }

  if (!activeTreatmentEpisode.treatmentPrograms?.length) {
    return 'A treatment program must be added to the treatment episode before a care plan can be created.';
  }

  if (hasActivePrimaryDiagnosis && (isModalityOptional || hasActiveModality)) {
    return 'No goals, problems, or interventions have been added to the care plan.';
  }
  if (isModalityOptional) {
    return 'A primary diagnosis must be added before a care plan can be created.';
  }
  return 'A primary diagnosis and modality must be added before a care plan can be created.';
};
